import * as ActionTypes from 'store/actionTypes';

export const changePhishingCampaignView = (fromPhishingView: any) => ({
  type: ActionTypes.SAVE_PHISHING_RESULTS_VIEW,

  payload: {
    fromPhishingView: fromPhishingView,
  }
});
